import axios, { CanceledError, isAxiosError } from 'axios';
import { ACCESS_TOKEN_KEY, API_URL, ID_TOKEN_KEY } from '../constants';
import { isTokenInvalid } from '../helpers';
import store from '../store';
import { addNotification } from '../store/notificationsSlice';
import { DEFAULT_ERROR } from '@/components/Notifications/Notification';
import { refreshTokens } from '../cognito';

export const client = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.request.use(
  async function (config) {
    const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY) || '';

    if (!accessToken) {
      return config;
    }

    if (isTokenInvalid(accessToken)) {
      await refreshTokens();
    }

    config.headers.set({
      ...config.headers,
      Authorization: `Bearer ${localStorage.getItem(ID_TOKEN_KEY)}`,
    });

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  function (response) {
    return response;
  },
  function (err) {
    if (
      err.config &&
      ((err.config.url === '/app/invitation' &&
        err.config.method.toLowerCase() === 'get') ||
        (err.config.url === '/client/invitations' &&
          err.config.method.toLowerCase() === 'post') ||
        // The incomplete-products download surfaces its own per-reason error
        // toast (see useProductData.handleDownload); skip the generic one.
        (err.config.url === '/client/products/incomplete/download' &&
          err.config.method.toLowerCase() === 'post') ||
        (err.config.url === '/client/proforma-invoices/download/month' &&
          err.config.method.toLowerCase() === 'post'))
    ) {
      return Promise.reject(err);
    }

    if (
      isAxiosError(err) &&
      !(err instanceof CanceledError) &&
      err.response?.status !== 404
    ) {
      store.dispatch(
        addNotification({
          text: DEFAULT_ERROR,
          type: 'error',
        })
      );
    }

    return Promise.reject(err);
  }
);
